import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade } from '../+state/customer.facade';
import { SessionService } from '../../auth/services';

import { Observable, of, race, timer } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class CustomerRequestAllowedGuard implements CanActivate {
    constructor(
        private customerFacade: CustomerFacade,
        private session: SessionService,
        private router: Router,
        private translate: TranslateService
    ) {}

    canActivate(): Observable<boolean> {
        if (!this.session.getLoginStatus()) {
            return of(false);
        }

        this.customerFacade.getCustomerProfile();

        return race(
            this.customerFacade.loaded$.pipe(
                filter((loaded) => loaded),
                switchMap(() => this.customerFacade.customerRequestAllowed$),
                take(1)
            ),
            timer(10000).pipe(map(() => true))
        ).pipe(
            take(1),
            tap((allowed) => {
                if (!allowed) {
                    this.router.navigate([this.translate.currentLang, 'account', 'profile']);
                }
            })
        );
    }
}
